// @flow
function convertToDollars(valueInCents: number): number {
  return valueInCents / 100;
}

export function formatCurrencyValue(value: number): string {
  const valueInDollars = convertToDollars(value);
  const formattedValue =
    valueInDollars % 1 === 0
      ? valueInDollars.toString()
      : valueInDollars.toFixed(2);
  return formattedValue;
}

export function formatCurrencyValueDecimals(value: number): number {
  const valueInDollars = convertToDollars(value);
  return valueInDollars.toFixed(2);
}

export function convertToCents(valueInDollars: string): number {
  return parseFloat(valueInDollars) * 100;
}

export function calculateCartItemTotal(
  quantity: number,
  salePrice: string,
  price: string
): string {
  const finalPrice = salePrice || price;
  const cartItemTotalInCents = convertToCents(finalPrice) * quantity;
  return formatCurrencyValue(cartItemTotalInCents);
}

export const formatCurrency = (num: number | string) =>
  Number(num).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
